import axios from "axios";
import * as ROUTES from "../../constants/routes";
import Helpers from "../Helpers";

const UPLOAD_URLS = {
  booking: `${ROUTES.FUNCTIONAL_BASE_URL_V2}admin/operations/upload-booking`,
  redemption: `${ROUTES.FUNCTIONAL_BASE_URL_V2}admin/operations/upload-redemption`,
};

export default class Functions {
  constructor() {
    this.helpers = new Helpers();
  }

  doUploadFile = (excelFile, email, uploadType) => {
    const token = this.helpers.getCookie("token");

    const url = UPLOAD_URLS[uploadType];

    if (!url) {
      return Promise.reject(new Error("Unsupported upload target"));
    }

    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("excel", excelFile.file);
      formData.append("req", JSON.stringify({ email: email }));
      axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          this.helpers.handleError(err);
          reject(err);
        });
    });
  };

  doChangePaymentValidity = (validObj) => {
    const token = this.helpers.getCookie("token");
    console.log(validObj);
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${ROUTES.FUNCTIONAL_BASE_URL}operations-operations/updatePaymentValidation`,
          JSON.stringify(validObj),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          this.helpers.handleError(err);
          reject(err);
        });
    });
  };
}
